import React from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { useParams } from "react-router";

let termsConditionsLink = "/Agent's mandate - EN.pdf";
let privacyPolicyLink = "/Annex D Client Privacy -EN.pdf";
let confidentialityObligationLink = "/Annex C NDNCA-EN.pdf";
let codeOfEthicsLink = "/Annex B Code of Ethics - EN.pdf";
let compensationPlanLink = "/Annex A Excelior Compensation Plan_v2.pdf";

const TermsAndConditions = ({ formik }) => {
  const { t } = useTranslation();
  const { lang } = useParams();

  if (lang === "it") {
    termsConditionsLink = "/Contratto di mandato Collaboratore-IT.pdf";
    privacyPolicyLink = "/Allegato D Privacy-IT.pdf";
    confidentialityObligationLink = "/Allegato C NDNCA-IT.pdf";
    codeOfEthicsLink = "/Allegato B Codice Etico-IT.pdf";
    compensationPlanLink = "/Allegato A Piano Compensi_Excelior_v2.pdf";
  }

  return (
    <>
      <Form.Group className="mb-3">
        <div
          className={
            formik.touched.acceptTermsConditions &&
            !!formik.errors.acceptTermsConditions
              ? "is-invalid"
              : ""
          }
        >
          <Form.Check
            type="checkbox"
            label={
              <>
                {t("i_accept")}{" "}
                <a
                  href={termsConditionsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "white" }}
                >
                  {t("form.termsConditions")}
                </a>
              </>
            }
            value={formik.values.acceptTermsConditions}
            name="acceptTermsConditions"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched.acceptTermsConditions &&
              !!formik.errors.acceptTermsConditions
            }
          />
        </div>
        <Form.Control.Feedback type="invalid">
          {t(`error.${formik.errors.acceptTermsConditions}`)}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3">
        <div
          className={
            formik.touched.acceptPrivacyPolicy &&
            !!formik.errors.acceptPrivacyPolicy
              ? "is-invalid"
              : ""
          }
        >
          <Form.Check
            type="checkbox"
            label={
              <>
                {t("i_accept")}{" "}
                <a
                  href={privacyPolicyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "white" }}
                >
                  {t("form.supplierCollaboratorInformation")}
                </a>
              </>
            }
            value={formik.values.acceptPrivacyPolicy}
            name="acceptPrivacyPolicy"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched.acceptPrivacyPolicy &&
              !!formik.errors.acceptPrivacyPolicy
            }
          />
        </div>
        <Form.Control.Feedback type="invalid">
          {t(`error.${formik.errors.acceptPrivacyPolicy}`)}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          label={
            <>
              {t("i_accept")}{" "}
              <a
                href={confidentialityObligationLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                {t("form.acceptObbligoRiservatezza")}
              </a>
            </>
          }
          value={formik.values.acceptConfidentialityAgreement}
          name="acceptConfidentialityAgreement"
          onChange={(e) =>
            formik.setFieldValue(
              "acceptConfidentialityAgreement",
              e.target.checked
            )
          }
        />
        <Form.Check
          type="checkbox"
          label={
            <>
              {t("i_accept")}{" "}
              <a
                href={codeOfEthicsLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                {t("form.acceptCodiceEticoBMGA")}
              </a>
            </>
          }
          name="acceptCodeOfEthics"
          onChange={(e) =>
            formik.setFieldValue("acceptCodeOfEthics", e.target.checked)
          }
        />
        <Form.Check
          type="checkbox"
          label={
            <>
              {t("i_accept")}{" "}
              <a
                href={compensationPlanLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                {t("form.acceptpianoCompensi")}
              </a>
            </>
          }
          name="acceptCompensationPlan"
          onChange={(e) =>
            formik.setValues({
              ...formik.values,
              acceptCompensationPlan: e.target.checked,
            })
          }
        />
      </Form.Group>
    </>
  );
};

export default TermsAndConditions;
